// Funciones
import { ROUTES } from "../../../../../const/routes";

/**
 * Assets de las fichas que se utilizan para elegir el monto de la apuesta
 * @param {*} scene 
 */
export function cargaAssetsFichasEleccion(scene) {
    // Ficha 10
    scene.load.image(
      "ficha10",
      ROUTES.rutaBlackJackFichasEleccion + "/ficha1EstaticaResized.png"
    );
    scene.load.image(
      "ficha10Hover",
      ROUTES.rutaBlackJackFichasEleccion + "/ficha1EstaticaHoverResized.png"
    );
    scene.load.image(
      "ficha10Selected",
      ROUTES.rutaBlackJackFichasEleccion + "/ficha1EstaticaSelectedResized.png"
    );

    // Ficha 20
    scene.load.image(
      "ficha20",
      ROUTES.rutaBlackJackFichasEleccion + "/ficha2EstaticaResized.png"
    );
    scene.load.image(
      "ficha20Hover",
      ROUTES.rutaBlackJackFichasEleccion + "/ficha2EstaticaHoverResized.png"
    );
    scene.load.image(
      "ficha20Selected",
      ROUTES.rutaBlackJackFichasEleccion + "/ficha2EstaticaSelectedResized.png"
    );

    // Ficha 50
    scene.load.image(
      "ficha50",
      ROUTES.rutaBlackJackFichasEleccion + "/ficha3EstaticaResized.png"
    );
    scene.load.image(
      "ficha50Hover",
      ROUTES.rutaBlackJackFichasEleccion + "/ficha3EstaticaHoverResized.png"
    );
    scene.load.image(
      "ficha50Selected",
      ROUTES.rutaBlackJackFichasEleccion + "/ficha3EstaticaSelectedResized.png"
    );

    // Ficha 100
    scene.load.image(
      "ficha100",
      ROUTES.rutaBlackJackFichasEleccion + "/ficha4EstaticaResized.png"
    );
    scene.load.image(
      "ficha100Hover",
      ROUTES.rutaBlackJackFichasEleccion + "/ficha4EstaticaHoverResized.png"
    );
    scene.load.image(
      "ficha100Selected",
      ROUTES.rutaBlackJackFichasEleccion + "/ficha4EstaticaSelectedResized.png"
    );
}